const React = require('react');

const buildHowToFixLink = (link) => {
  if (!link) return <></>;

  return (
    <a
      style={{ textDecoration: 'none', cursor: 'pointer' }}
      className="info"
      href={link}
      // eslint-disable-next-line react/jsx-no-target-blank
      target="_blank"
      title="This is a link to a how-to fix the issue."
      onClick={(e) => e.stopPropagation()}
    >
      📖
    </a>
  );
};

module.exports.buildHowToFixLink = buildHowToFixLink;
